import React from 'react';

export interface GridProps {
	children: React.ReactNode,
	className?: string
	element?: string
	mobileBlock?: boolean
	defaultPageRows?: boolean
}
export interface GridElementProps {
	children: React.ReactNode
	className?: string
	customStyle?: React.CSSProperties
	position?: string
	type?: string
	top?: boolean
}

const GridElement = ({ children, position, type, top, className, customStyle }: GridElementProps)=>{

	return (
		<div
			style={ customStyle }
			className={ `lhp-grid-element ${className || ''} ${ position ? `lhp-grid-element-${position}` : '' } ${ type ? `lhp-grid-element-${type}` : '' } ${ top ? 'lhp-grid-element-top' : '' }` }
		>
			{ children }
		</div>
	);
};

const GridComponent = Object.assign(
	React.forwardRef(
		function Grid(props: GridProps, ref: React.Ref<HTMLDivElement>) {
			if (props.element === 'section'){
				return (
					<section className={ `lhp-grid ${props.className || ''} ${props.mobileBlock ? 'lhp-grid-mobile-block' : ''} ${props.defaultPageRows ? 'lhp-grid-default-page' : ''}` } ref={ ref }>
						{ props.children }
					</section>
				);
			}

			return (
				<div className={ `lhp-grid ${props.className || ''} ${props.mobileBlock ? 'lhp-grid-mobile-block' : ''} ${props.defaultPageRows ? 'lhp-grid-default-page' : ''}` } ref={ ref }>
					{ props.children }
				</div>
			);
		}
	),
	{
		Element: GridElement
	}
);

const Grid = GridComponent;
export default Grid;
